import { EReadyAccommodate } from 'shared/repositories/cian-dobro/entities/property/AddRealEstateRequestSchema';
import { EStatus } from 'shared/repositories/cian-dobro/entities/property/ChangeStatusRequestSchema';

export interface IOffer {
  id: number;
  additionalPhone: string;
  address: string;
  area?: number;
  availableFor: string[];
  readyAccommodate: EReadyAccommodate[];
  availablePeriod: string;
  bedsCount?: number;
  bedsDescription: string;
  createdAt: string;
  facilities: string[];
  floor?: number;
  guestsCount: number;
  location: string;
  name: string;
  objectType: EObjectType;
  otherWishes: string;
  phone: string;
  priceDescription: string;
  priceType: EPriceType;
  roomsCount?: ERoomsCount;
  status: EStatus;
  comment: string;
  telegram: string;
  assignedFund: boolean;
  fundName?: string;
}

export interface IUser {
  isCustomerService: boolean;
  fundName?: string;
}

export enum EOfferType {
  FreeToApply = 'freeToApply',
  InWork = 'inWork',
}

export enum EObjectType {
  Bed = 'bed',
  Flat = 'flat',
  House = 'house',
  Room = 'room',
}

export enum EPriceType {
  Free = 'free',
  Symbolic = 'symbolic',
  Utility_bill = 'utility_bill',
}

export enum ERoomsCount {
  Five = 'five',
  Four = 'four',
  One = 'one',
  Six_and_more = 'six_and_more',
  Studio = 'studio',
  Three = 'three',
  Two = 'two',
}

export { EStatus };
